module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "inbox"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("Inbox"), _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Inbox is for private messaging members of Portal'),
      expression: "'Inbox is for private messaging members of Portal'"
    }],
    staticClass: "clippie fa fa-info-circle"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "tab-body"
  }, [_c('p', [_vm._v("We’ve phased out Inbox for our new "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openChat()
      }
    }
  }, [_vm._v("Chat App!")]), _c('br'), _vm._v("\n        October intake, we’ll leave this up to save your messages if you want."), _c('br'), _vm._v("\n        We’ll remove Inbox entirely in a few weeks, thanks for your feedback!")]), _vm._v(" "), _c('ul', {
    staticClass: "tabs clearfix"
  }, [_c('li', {
    on: {
      "click": function($event) {
        _vm.tab = 'compose'
      }
    }
  }, [_c('span', {
    class: {
      'active': _vm.tab === 'compose'
    }
  }, [_vm._v("Compose")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.tab = 'inbox';
        _vm.selectedMessage = null;
        _vm.getMessages('to', false)
      }
    }
  }, [_c('span', {
    class: {
      'active': _vm.tab === 'inbox'
    }
  }, [_vm._v("Inbox")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.tab = 'sent';
        _vm.selectedMessage = null;
        _vm.getMessages('from', false)
      }
    }
  }, [_c('span', {
    class: {
      'active': _vm.tab === 'sent'
    }
  }, [_vm._v("Sent")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.tab = 'trash';
        _vm.selectedMessage = null;
        _vm.getMessages('both', true)
      }
    }
  }, [_c('span', {
    class: {
      'active': _vm.tab === 'trash'
    }
  }, [_vm._v("Trash")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.tab = 'support'
      }
    }
  }, [_c('span', {
    class: {
      'active': _vm.tab === 'support'
    }
  }, [_vm._v("Support")])])])]), _vm._v(" "), (_vm.tab === 'compose') ? _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('form', {
    staticClass: "new-message",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.send()
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-tag-wrapper form-control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchTerm),
      expression: "searchTerm"
    }],
    attrs: {
      "type": "text",
      "placeholder": "To:"
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._l((_vm.recipients), function(recipient) {
    return _c('span', {
      staticClass: "tag",
      on: {
        "click": function($event) {
          _vm.toggleRecipient(recipient)
        }
      }
    }, [_c('img', {
      staticClass: "role-icon",
      attrs: {
        "src": _vm._f("roleIcon")(recipient.roles)
      }
    }), _vm._v(" " + _vm._s(recipient.firstName) + " " + _vm._s(recipient.lastName) + "\n                    ")])
  })], 2), _vm._v(" "), (_vm.users && _vm.searchTerm) ? _c('ul', {
    staticClass: "users"
  }, [_vm._l((_vm.users), function(user) {
    return _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.filterUsers(user.firstName + ' ' + user.lastName)),
        expression: "filterUsers(user.firstName + ' ' + user.lastName)"
      }],
      on: {
        "click": function($event) {
          _vm.toggleRecipient(user)
        }
      }
    }, [_c('img', {
      staticClass: "role-icon",
      attrs: {
        "src": _vm._f("roleIcon")(user.roles)
      }
    }), _vm._v(" " + _vm._s(user.firstName) + " " + _vm._s(user.lastName))])
  }), _vm._v(" "), _vm._l((_vm.groups), function(group) {
    return _c('li', {
      on: {
        "click": function($event) {
          _vm.addGroupMembers(group)
        }
      }
    }, [_vm._v("Send to Group " + _vm._s(group))])
  })], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message.title),
      expression: "message.title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Subject"
    },
    domProps: {
      "value": (_vm.message.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message.title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('vue-html5-editor', {
    attrs: {
      "content": _vm.messageContent,
      "height": 200
    },
    on: {
      "change": _vm.updateMessageContent
    }
  })], 1), _vm._v(" "), _vm._m(0)])])]) : _vm._e(), _vm._v(" "), (_vm.tab === 'inbox') ? _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body nopad"
  }, [(_vm.messages) ? _c('ul', {
    staticClass: "messages"
  }, _vm._l((_vm.messages), function(message, index) {
    return _c('li', {
      staticClass: "clearfix"
    }, [(!message.replies || message.replies.length === 0) ? _c('div', {
      staticClass: "table-row message",
      on: {
        "click": function($event) {
          _vm.selectMessage(message, index);
          _vm.showMessage = message.id
        }
      }
    }, [_c('div', {
      staticClass: "col-xs-12 col-md-2 avatar-wrapper"
    }, [(message.readBy.indexOf(_vm.localStorage.user_id) === -1) ? _c('span', {
      staticClass: "badge new-message"
    }, [_vm._v("New")]) : _vm._e(), _vm._v(" "), _c('img', {
      staticClass: "avatar-image",
      attrs: {
        "src": message.sender.avatar
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-md-4"
    }, [_c('span', {
      staticClass: "bold"
    }, [_vm._v("From: "), _c('img', {
      staticClass: "role-icon",
      attrs: {
        "src": _vm._f("roleIcon")(message.sender.roles)
      }
    }), _vm._v(" " + _vm._s(message.sender.firstName) + " " + _vm._s(message.sender.lastName))]), _c('br'), _vm._v("\n                    " + _vm._s(_vm._f("shortDate")(message.createdAt)) + "\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-md-9"
    }, [_c('span', {
      staticClass: "bold"
    }, [_vm._v(_vm._s(message.title))]), _vm._v(" "), _c('p', {
      staticClass: "excerpt"
    }, [_vm._v(_vm._s(_vm._f("excerpt")(message.body)))])])]) : _c('div', {
      staticClass: "table-row message",
      on: {
        "click": function($event) {
          _vm.selectMessage(message, index);
          _vm.showMessage = message.id
        }
      }
    }, [_c('div', {
      staticClass: "col-xs-12 col-md-2 avatar-wrapper"
    }, [(message.readBy.indexOf(_vm.localStorage.user_id) === -1) ? _c('span', {
      staticClass: "badge new-message"
    }, [_vm._v("New")]) : _vm._e(), _vm._v(" "), _c('img', {
      staticClass: "avatar-image",
      attrs: {
        "src": message.replies[0].sender.avatar
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-md-4"
    }, [_c('span', {
      staticClass: "bold"
    }, [_vm._v("From: "), _c('img', {
      staticClass: "role-icon",
      attrs: {
        "src": _vm._f("roleIcon")(message.replies[0].sender.roles)
      }
    }), _vm._v(" " + _vm._s(message.replies[0].sender.firstName) + " " + _vm._s(message.replies[0].sender.lastName))]), _c('br'), _vm._v("\n                    " + _vm._s(_vm._f("shortDate")(message.replies[0].createdAt)) + "\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-md-9"
    }, [_c('span', {
      staticClass: "bold"
    }, [_vm._v("Re: " + _vm._s(message.title))]), _vm._v(" "), _c('p', {
      staticClass: "excerpt"
    }, [_vm._v(_vm._s(_vm._f("excerpt")(message.replies[0].body)))])])]), _vm._v(" "), (_vm.selectedMessage && _vm.showMessage === message.id) ? _c('div', {
      staticClass: "col-xs-12 body"
    }, [_c('h3', [_vm._v(_vm._s(message.title))]), _vm._v(" "), _c('div', {
      staticClass: "message-body",
      domProps: {
        "innerHTML": _vm._s(_vm.$options.filters.linkify(message.body))
      }
    }), _vm._v(" "), (_vm.replies) ? _c('ul', {
      staticClass: "replies"
    }, _vm._l((_vm.replies), function(reply) {
      return _c('li', {
        staticClass: "clearfix"
      }, [_c('div', {
        staticClass: "col-xs-12 col-md-2 text-center avatar-message"
      }, [_c('img', {
        staticClass: "avatar-image",
        attrs: {
          "src": reply.sender.avatar
        }
      }), _vm._v(" "), _c('img', {
        staticClass: "role-icon",
        attrs: {
          "src": _vm._f("roleIcon")(reply.sender.roles)
        }
      }), _vm._v("\n\n                                    " + _vm._s(reply.sender.firstName) + " " + _vm._s(reply.sender.lastName)), _c('br'), _vm._v("                \n                                    " + _vm._s(_vm._f("shortDate")(reply.createdAt)) + "\n                                ")]), _vm._v(" "), _c('div', {
        staticClass: "col-xs-12 col-md-10"
      }, [_c('div', {
        domProps: {
          "innerHTML": _vm._s(_vm.$options.filters.linkify(reply.body))
        }
      })])])
    })) : _vm._e(), _vm._v(" "), _c('form', {
      staticClass: "col-xs-12",
      on: {
        "submit": function($event) {
          $event.preventDefault();
          _vm.reply(message.to)
        }
      }
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('vue-html5-editor', {
      attrs: {
        "content": _vm.replyContent,
        "height": 200
      },
      on: {
        "change": _vm.updateReplyContent
      }
    })], 1), _vm._v(" "), _c('button', {
      staticClass: "btn btn-success",
      attrs: {
        "type": "submit"
      }
    }, [_vm._v("Reply")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger delete",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.deleteMessage(message, index)
        }
      }
    }, [_vm._v("Delete")])])]) : _vm._e()])
  })) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.messages && _vm.messages.length > 10000),
      expression: "messages && messages.length > 10000"
    }],
    staticClass: "message-pagination"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.getPrevious('to', false)
      }
    }
  }, [_vm._v("Previous")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 text-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.getNext('to', false)
      }
    }
  }, [_vm._v("Next")])])])])]) : _vm._e(), _vm._v(" "), (_vm.tab === 'sent') ? _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body nopad"
  }, [(_vm.messages) ? _c('ul', {
    staticClass: "messages"
  }, _vm._l((_vm.messages), function(message, index) {
    return _c('li', {
      staticClass: "clearfix"
    }, [(message.to) ? _c('div', {
      staticClass: "table-row message",
      on: {
        "click": function($event) {
          _vm.selectMessage(message);
          _vm.showMessage = message.id
        }
      }
    }, [_c('div', {
      staticClass: "col-xs-12 col-md-2 avatar-wrapper"
    }, [_c('img', {
      staticClass: "avatar-image",
      attrs: {
        "src": message.recipient.avatar
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-md-4"
    }, [_c('span', {
      staticClass: "bold"
    }, [_vm._v("To: "), _c('img', {
      staticClass: "role-icon",
      attrs: {
        "src": _vm._f("roleIcon")(message.recipient.roles)
      }
    }), _vm._v(" " + _vm._s(message.recipient.firstName) + " " + _vm._s(message.recipient.lastName))]), _c('br'), _vm._v("\n                    \n                    " + _vm._s(_vm._f("dayOnly")(message.createdAt)) + "\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-md-9"
    }, [_c('span', {
      staticClass: "bold"
    }, [_vm._v(_vm._s(message.title))]), _vm._v(" "), _c('p', {
      staticClass: "excerpt"
    }, [_vm._v(_vm._s(_vm._f("excerpt")(message.body)))])])]) : _vm._e(), _vm._v(" "), (_vm.selectedMessage && _vm.showMessage === message.id) ? _c('div', {
      staticClass: "col-xs-12 body"
    }, [_c('h3', [_vm._v(_vm._s(message.title))]), _vm._v(" "), _c('div', {
      staticClass: "message-body",
      domProps: {
        "innerHTML": _vm._s(_vm.$options.filters.linkify(message.body))
      }
    }), _vm._v(" "), (_vm.replies) ? _c('ul', {
      staticClass: "replies"
    }, _vm._l((_vm.replies), function(reply) {
      return _c('li', {
        staticClass: "clearfix"
      }, [(reply.sender) ? _c('div', {
        staticClass: "col-xs-12 col-md-2 text-center"
      }, [_c('img', {
        staticClass: "avatar-image",
        attrs: {
          "src": reply.sender.avatar
        }
      }), _vm._v("\n                                    " + _vm._s(reply.sender.firstName) + " " + _vm._s(reply.sender.lastName)), _c('br'), _vm._v("                \n                                    " + _vm._s(_vm._f("shortDate")(reply.createdAt)) + "\n                                ")]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "col-xs-12 col-md-10"
      }, [_c('div', {
        domProps: {
          "innerHTML": _vm._s(_vm.$options.filters.linkify(reply.body))
        }
      })])])
    })) : _vm._e(), _vm._v(" "), _c('form', {
      staticClass: "col-xs-12",
      on: {
        "submit": function($event) {
          $event.preventDefault();
          _vm.reply()
        }
      }
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('vue-html5-editor', {
      attrs: {
        "content": _vm.replyContent,
        "height": 200
      },
      on: {
        "change": _vm.updateReplyContent
      }
    })], 1), _vm._v(" "), _c('button', {
      staticClass: "btn btn-success",
      attrs: {
        "type": "submit"
      }
    }, [_vm._v("Reply")])])]) : _vm._e()])
  })) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "message-pagination"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.getPrevious('from', false)
      }
    }
  }, [_vm._v("Previous")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 text-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.getNext('from', false)
      }
    }
  }, [_vm._v("Next")])])])])]) : _vm._e(), _vm._v(" "), (_vm.tab === 'trash') ? _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body nopad"
  }, [(_vm.messages) ? _c('ul', {
    staticClass: "messages"
  }, _vm._l((_vm.messages), function(message, index) {
    return _c('li', {
      staticClass: "clearfix",
      on: {
        "click": function($event) {
          _vm.selectMessage(message);
          _vm.showMessage = message.id
        }
      }
    }, [_c('div', {
      staticClass: "table-row message"
    }, [_c('div', {
      staticClass: "col-xs-12 col-md-2 avatar-wrapper"
    }, [_c('img', {
      staticClass: "avatar-image",
      attrs: {
        "src": message.sender.avatar
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-md-3"
    }, [_c('span', {
      staticClass: "bold"
    }, [_vm._v("From: " + _vm._s(message.sender.firstName) + " " + _vm._s(message.sender.lastName))]), _c('br'), _vm._v("\n                    " + _vm._s(_vm._f("dayOnly")(message.createdAt)) + "\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-md-6"
    }, [_c('span', {
      staticClass: "bold"
    }, [_vm._v(_vm._s(message.title))]), _vm._v(" "), _c('p', {
      staticClass: "excerpt"
    }, [_vm._v(_vm._s(_vm._f("excerpt")(message.body)))])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-md-3"
    }, [_c('span', {
      staticClass: "bold"
    }, [_vm._v("Deleted:")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._f("dayOnly")(message.deletedAt)))])])]), _vm._v(" "), (_vm.showMessage === message.id) ? _c('div', {
      staticClass: "col-xs-12 body"
    }, [_c('h3', [_vm._v(_vm._s(message.title))]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.undeleteMessage(message.id)
        }
      }
    }, [_vm._v("Restore")]), _vm._v(" "), _c('div', {
      staticClass: "message-body",
      domProps: {
        "innerHTML": _vm._s(_vm.$options.filters.linkify(message.body))
      }
    }), _vm._v(" "), (_vm.replies) ? _c('ul', {
      staticClass: "replies"
    }, _vm._l((message.replies), function(reply) {
      return _c('li', {
        staticClass: "clearfix"
      }, [_c('div', {
        staticClass: "col-xs-12 col-md-2 text-center avatar-wrapper"
      }, [_c('img', {
        staticClass: "avatar-image",
        attrs: {
          "src": reply.sender.avatar
        }
      }), _vm._v(" "), _c('img', {
        staticClass: "role-icon",
        attrs: {
          "src": _vm._f("roleIcon")(reply.sender.roles)
        }
      }), _vm._v(" " + _vm._s(reply.sender.firstName) + " " + _vm._s(reply.sender.lastName)), _c('br'), _vm._v("                \n                                    " + _vm._s(_vm._f("shortDate")(reply.createdAt)) + "\n                                ")]), _vm._v(" "), _c('div', {
        staticClass: "col-xs-12 col-md-10"
      }, [_c('div', {
        domProps: {
          "innerHTML": _vm._s(_vm.$options.filters.linkify(reply.body))
        }
      })])])
    })) : _vm._e()]) : _vm._e()])
  })) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "message-pagination"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.getPrevious('both', true)
      }
    }
  }, [_vm._v("Previous")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 text-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.getNext('both', true)
      }
    }
  }, [_vm._v("Next")])])])])]) : _vm._e(), _vm._v(" "), (_vm.tab === 'support') ? _c('div', [_c('support')], 1) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Send")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1dbf04cc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Inbox.vue
// module id = 1966
// module chunks = 2